<svg width="368" height="5" viewBox="0 0 368 5" xmlns="http://www.w3.org/2000/svg">
<path d="M0 0H368L364.579 4.25354C364.199 4.7255 363.626 5 363.02 5H4.97983C4.37412 5 3.80106 4.72551 3.42143 4.25354L0 0Z"/>
</svg>
